var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMediumPressure(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_95_48458)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 45.9784L12.0033 45.4784H12H-0.0216222C-3.04725 45.4784 -5.5 43.0256 -5.5 40C-5.5 36.9624 -3.03757 34.5 0 34.5H12H18.3179C20.6369 34.5 22.9125 35.1293 24.902 36.3209C29.2721 38.9382 34.7279 38.9382 39.098 36.3209C41.0875 35.1293 43.3631 34.5 45.6822 34.5H52H64C67.0376 34.5 69.5 36.9624 69.5 40C69.5 43.0256 67.0472 45.4784 64.0216 45.4784L52 45.4784L51.996 45.4784L52 45.9784L51.9959 45.4784L51.9957 45.4784L51.9949 45.4784L51.9916 45.4784L51.9785 45.4785L51.9268 45.4789L51.7269 45.4804C51.5527 45.4816 51.2996 45.4833 50.9835 45.4852C50.3514 45.489 49.4679 45.4936 48.4625 45.4966C46.451 45.5027 43.9542 45.5027 42.0062 45.4784C39.6422 45.449 37.9026 45.4583 36.0354 45.4684C34.8151 45.475 33.5403 45.4819 32.0011 45.4784C30.8224 45.4757 29.7858 45.4712 28.8133 45.467C26.2416 45.4558 24.1175 45.4466 20.9949 45.4784C19.2412 45.4963 16.9939 45.4963 15.1835 45.4918C14.2786 45.4896 13.4835 45.4862 12.9146 45.4834C12.6301 45.482 12.4022 45.4808 12.2455 45.4799L12.0656 45.4788L12.019 45.4785L12.0072 45.4784L12.0042 45.4784L12.0035 45.4784L12.0033 45.4784L12 45.9784Z",
    stroke: "#404D6A"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 4.23212,
    y1: 38.0928,
    x2: 2.23212,
    y2: 43.0928,
    stroke: "#B1B6C2",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 11.2321,
    y1: 38.0928,
    x2: 9.23212,
    y2: 43.0928,
    stroke: "#B1B6C2",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 18.2321,
    y1: 38.0928,
    x2: 16.2321,
    y2: 43.0928,
    stroke: "#B1B6C2",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 24.2372,
    y1: 40.0791,
    x2: 23.2372,
    y2: 43.0791,
    stroke: "#B1B6C2",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.5 40L37.2321 43.0929",
    stroke: "#B1B6C2",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 46.2321,
    y1: 38.0928,
    x2: 44.2321,
    y2: 43.0928,
    stroke: "#B1B6C2",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 53.2321,
    y1: 38.0928,
    x2: 51.2321,
    y2: 43.0928,
    stroke: "#B1B6C2",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 60.2321,
    y1: 38.0928,
    x2: 58.2321,
    y2: 43.0928,
    stroke: "#B1B6C2",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21 30H21.5177C23.6227 30 25.692 30.5438 27.525 31.5787V31.5787C30.2029 33.0907 33.4607 33.1586 36.1993 31.7597L36.7168 31.4953C38.6409 30.5125 40.7706 30 42.9311 30H43",
    stroke: "#404D6A"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_95_48458"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 64,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMediumPressure);
export default __webpack_public_path__ + "static/media/medium-pressure.928a8d1b23e6361b1a794f3e1e20166e.svg";
export { ForwardRef as ReactComponent };